import { render, staticRenderFns } from "./ArticleManAdmin.vue?vue&type=template&id=3c70c9fa&scoped=true&"
import script from "./ArticleManAdmin.vue?vue&type=script&lang=js&"
export * from "./ArticleManAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ArticleManAdmin.vue?vue&type=style&index=0&id=3c70c9fa&prod&scoped=true&lang=css&"
import style1 from "./ArticleManAdmin.vue?vue&type=style&index=1&id=3c70c9fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c70c9fa",
  null
  
)

export default component.exports